import * as geoApi from '../api/geo'
import {
  ERROR_RECEIVING_USER_LOCATION_PROPERTIES,
  RECEIVE_USER_LOCATION_PROPERTIES,
  REQUEST_USER_LOCATION_PROPERTIES,
} from '../action_constants'

function requestCurrentUserLocation() {
  return {
    type: REQUEST_USER_LOCATION_PROPERTIES,
  }
}

function receiveCurrentUserLocation(data) {
  return {
    type: RECEIVE_USER_LOCATION_PROPERTIES,
    payload: data,
  }
}

function errorReceivingCurrentUserLocation(error) {
  return {
    type: ERROR_RECEIVING_USER_LOCATION_PROPERTIES,
    error,
  }
}

// Shared in-flight lookup so concurrent callers don't trigger extra requests
let pendingLookup = null

export function getUserLocationProperties(opts) {
  return async function(dispatch) {
    if (pendingLookup) return pendingLookup
    dispatch(requestCurrentUserLocation())
    pendingLookup = geoApi
      .ipLookup(opts)
      .then(res => {
        // geoApi.ipLookup resolves with the Error on network failures, and
        // non-2xx responses still resolve: both must end up as an error so
        // ensureUserLocationProperties doesn't retry on every call
        if (res?.ok) {
          dispatch(receiveCurrentUserLocation(res.data))
        } else {
          dispatch(errorReceivingCurrentUserLocation(res?.data || res))
        }
      })
      .catch(err => dispatch(errorReceivingCurrentUserLocation(err)))
      .finally(() => {
        pendingLookup = null
      })
    return pendingLookup
  }
}

// Resolves once the location is known. API endpoints that run ipLookup wait
// for this so they reuse the userProperties cookie set by /iplookup
export function ensureUserLocationProperties() {
  return async function(dispatch, getState) {
    const { countryCode, error } = getState().userProperties
    if (countryCode || error) return
    return dispatch(getUserLocationProperties())
  }
}
